module.exports = __webpack_public_path__ + "static/media/s63.932f613c.jpg";